import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	postWrapper: {
		height     : "100%",
		background : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey
	}
} ) );
